export default {"src":"/_next/static/media/bg-left-image.bd259f4b.svg","height":582,"width":520,"blurWidth":0,"blurHeight":0};